import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Otsikko',
      placeholder: 'Anna ilmoituksen otsikko',
    },
    body: {
      label: 'Viestin sisältö',
      placeholder: 'Kirjoita viestisi',
    },
    promo_code: {
      label: 'Alennuskoodi',
      placeholder: 'Valitse alennuskoodi',
    },
    offers: {
      label: 'Tarjoukset',
      placeholder: 'Valitse tarjous',
    },
    campaign_type: {
      label: 'Kampanjan tyyppi',
      placeholder: 'Valitse kampanjan tyyppi',
    },
    tone: {
      label: 'Äänensävy',
      placeholder: 'Valitse sävy',
    },
  },
  attachment: {
    heading: 'Mitä tämä kampanja mainostaa?',
    offer: {
      title: 'Tarjous',
      description: 'Valitse aktiivisista tarjouksistasi.',
    },
    promo_code: {
      title: 'Alennuskoodi',
      description: 'Valitse aktiivisista alennuskoodeistasi.',
    },
  },
  buttons: {
    generate: 'Luo',
    improve: 'Paranna tekoälyllä',
    undo: 'Kumoa ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Ystävällinen 🙂',
    [ToneTypes.Elegant]: 'Tyylikäs ✨',
    [ToneTypes.Playful]: 'Leikkisä 🎉',
    [ToneTypes.Professional]: 'Ammattimainen 👨‍💼',
    [ToneTypes.Informative]: 'Informatiivinen 📊',
    [ToneTypes.Persuasive]: 'Vakuuttava 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Myyvä 🚀',
    [CampaignTypes.Informational]: 'Informoiva ℹ️',
  },
  no_promo_codes: {
    title: 'Ei kelpoisia alennuskoodeja',
    description: 'Luo uusi alennuskoodi.',
    create_promo_code: 'Luo alennuskoodi',
  },
  no_offers: {
    title: 'Ei aktiivisia tarjouksia',
    description: 'Luo uusi tarjous.',
    create_offer: 'Luo tarjous',
  },
  feedback: {
    success: 'Luotu onnistuneesti',
    error: 'Luonti epäonnistui',
  },
};
